const MixinNotification = {
  methods: {
    showNotification(message, type, icon, title, position = 'top-right') {
      this.$emit('showNotification', {
        message: message,
        type: type,
        icon: icon,
        title: title,
        position: position,
      });
    },
  },
};

export { MixinNotification };
